module.exports = {
          srcSet: __webpack_public_path__ + "f01e857bba051d6805326918092f1ed3-501.png"+" 501w",
          images:[ {path: __webpack_public_path__ + "f01e857bba051d6805326918092f1ed3-501.png",width: 501,height: 282}],
          src: __webpack_public_path__ + "f01e857bba051d6805326918092f1ed3-501.png",
          toString:function(){return __webpack_public_path__ + "f01e857bba051d6805326918092f1ed3-501.png"},
          
          width: 501,
          height: 282
        }